// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label1 {
  font-weight: 500;
  font-size: 0.8rem;
  line-height: 120%;
  text-transform: uppercase;
  padding: 0;
  margin: 0.625rem 0;
  color: var(--ion-color-secondary-black);
  opacity: 1;
  max-width: 75%;
}

.label2 {
  font-weight: 500;
  font-size: 0.9rem;
  line-height: 120%;
  text-transform: uppercase;
  padding: 0;
  margin: 0;
}

.label3 {
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 120%;
  text-transform: uppercase;
  padding: 0;
  margin: 0;
}

.label4 {
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 120%;
  text-transform: uppercase;
  padding: 0;
  margin: 0;
}

.divider-line {
  height: 1px;
  width: 100%;
  background: var(--ion-divider);
}

.mv-10 {
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}

.display-div {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.text-end {
  float: right;
  text-align: end;
  white-space: nowrap;
}

.width-inherit {
  width: inherit;
}

.main-div {
  width: 100%;
  display: flow-root;
}

.sub-div {
  width: 40%;
  float: right;
}

.mb-40 {
  margin-bottom: 2.5rem;
}

.font-bold {
  font-weight: 700;
}

.help-icon {
  margin: 0 0.3125rem;
  height: 0.875rem;
  vertical-align: bottom;
  cursor: pointer;
}

.order-summary {
  font: normal normal bold 1.5rem/24px Noto Sans;
  color: var(--ion-color-primary-black);
  opacity: 1;
  margin: 0 0 2rem 0;
}

.mt-70 {
  margin-top: 4.375rem;
}

.color-app-orange {
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  letter-spacing: 0;
  color: var(--ion-orange-primary);
  opacity: 1;
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  text-transform: capitalize;
  min-width: 240px;
  line-height: 1.3rem;
  width: -webkit-fill-available;
  margin: 0px 2px;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-summary/order-summary.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,uCAAA;EACA,UAAA;EACA,cAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,SAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,SAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,8BAAA;AACJ;;AAEA;EACI,oBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AACJ;;AAEA;EACI,YAAA;EACA,eAAA;EACA,mBAAA;AACJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,UAAA;EACA,YAAA;AAAJ;;AAGA;EACI,qBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,8CAAA;EACA,qCAAA;EACA,UAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,oBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,UAAA;AAAJ;;AAGA,iBAAA;AACA;EACI,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AAAJ;;AAGA,oEAAA;AACA;EACI,mBAAA;AAAJ","sourcesContent":[".label1 {\n    font-weight: 500;\n    font-size: 0.8rem; //12px\n    line-height: 120%;\n    text-transform: uppercase;\n    padding: 0;\n    margin: 0.625rem 0;\n    color: var(--ion-color-secondary-black);\n    opacity: 1;\n    max-width: 75%;;\n}\n\n.label2 {\n    font-weight: 500;\n    font-size: 0.9rem;\n    line-height: 120%;\n    text-transform: uppercase;\n    padding: 0;\n    margin: 0;\n}\n\n.label3 {\n    font-weight: 600;\n    font-size: 0.9rem;\n    line-height: 120%;\n    text-transform: uppercase;\n    padding: 0;\n    margin: 0;\n}\n\n.label4 {\n    font-weight: 700;\n    font-size: 1.2rem;\n    line-height: 120%;\n    text-transform: uppercase;\n    padding: 0;\n    margin: 0;\n}\n\n.divider-line {\n    height: 1px;\n    width: 100%;\n    background: var(--ion-divider);\n}\n\n.mv-10 {\n    margin-top: 0.625rem;\n    margin-bottom: 0.625rem;\n}\n\n.display-div {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.text-end {\n    float: right;\n    text-align: end;\n    white-space: nowrap;\n    // width: 100%;\n}\n\n.width-inherit {\n    width: inherit;\n}\n\n.main-div {\n    width: 100%;\n    display: flow-root;\n}\n\n.sub-div {\n    width: 40%;\n    float: right;\n}\n\n.mb-40 {\n    margin-bottom: 2.5rem;\n}\n\n.font-bold {\n    font-weight: 700;\n}\n\n.help-icon {\n    margin: 0 0.3125rem;\n    height: 0.875rem;\n    vertical-align: bottom;\n    cursor: pointer;\n}\n\n.order-summary {\n    font: normal normal bold 1.5rem /24px Noto Sans;\n    color: var(--ion-color-primary-black);\n    opacity: 1;\n    margin: 0 0 2rem 0;\n}\n\n.mt-70 {\n    margin-top: 4.375rem;\n}\n\n.color-app-orange {\n    font-size: 1rem;\n    line-height: 1.5rem;\n    font-weight: 500;\n    letter-spacing: 0;\n    color: var(--ion-orange-primary);\n    opacity: 1;\n}\n\n/* Tooltip text */\n.tooltip .tooltiptext {\n    visibility: hidden;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    padding: 5px;\n    border-radius: 6px;\n    position: absolute;\n    z-index: 1;\n    text-transform: capitalize;\n    min-width: 240px;\n    line-height: 1.3rem;\n    width: -webkit-fill-available;\n    margin: 0px 2px;\n}\n\n/* Show the tooltip text when you mouse over the tooltip container */\n.tooltip:hover .tooltiptext {\n    visibility: visible;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
